export default "__VITE_ASSET__CRyRN_gc__"